import React from "react";
import { Text, LegacyCard as Card, InlineStack } from "@shopify/polaris";

const AdminPlanCard = () => (
  <Card title="Subscription Plan" actions={[{ content: "Upgrade" }]}>
    <Card.Section subdued>
      <InlineStack>
        <div>
          <Text as="span">Growth</Text>
          <Text variant="bodySm" as="p">
            Count of new products
          </Text>
        </div>
        <Text>$79/m</Text>
      </InlineStack>
    </Card.Section>
  </Card>
);

export default AdminPlanCard;
